import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { WORKSPACE_FORM_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const GET_WORKSPACE_FOR_FORM: TypedDocumentNode<Data, Variables> = gql`
  ${WORKSPACE_FORM_FRAGMENT}

  query getWorkspaceForForm($id: ID!) {
    node(id: $id) {
      ... on Workspace {
        ...WorkspaceFormFragment
      }
    }
  }
`
